module.exports = __webpack_public_path__ + "sunsemweb/img/dddlogo2.d7d763a8.png";